<template>
    <form-builder :url="url" :method="method" :fields="fields" :argsdata="args.formobjects" :success="onSuccess">
    </form-builder>
</template>

<script>
import FormBuilder from '../../frontend/components/FormBuilder';
export default {
    components: {
        FormBuilder
    },
    props: {
        args: null
    },
    methods: {
        onSuccess() {
            location.href = "/profiles";
        }
    },
    mounted() {
        console.log(this.args)
    },
    data() {
        return {
            url: '/profiles/' + this.args.formobjects.id,
            method: 'patch',
            fields: [
                { type: 'text', name: 'name', label: __('profile.profile_name') },
                { type: 'select', name: 'boardtype', label: __('profile.board_type'), options: [{ id: 1, name: __('profile.board_type_option1') }, { id: 2, name: __('profile.board_type_option2') }], noblank: true },
                {
                    type: 'select', name: 'layout', label: __('profile.layout_game'), options: [
                        { id: 1, name: __('profile.layout_option1') },
                        { id: 2, name: __('profile.layout_option2') },
                        { id: 3, name: __('profile.layout_option3') },
                        // { id: 4, name: __('profile.layout_option4') },
                        // { id: 5, name: __('profile.layout_option5') }
                    ], noblank: true
                },
                { type: 'toggle', name: 'show_numpad', label: __('profile.show_numpad') },
                { type: 'toggle', name: 'show_history', label: __('profile.show_history') },
                { type: 'toggle', name: 'autostart_webcams', label: __('profile.autostart_webcams') },
                { type: 'toggle', name: 'use_website_sounds', label: __('profile.use_website_sounds') },
                { type: 'select', name: 'sounds', label: __('profile.sound_selection'), options: [{ id: 1, name: __('profile.sound_selection_option1') }, { id: 2, name: __('profile.sound_selection_option2') }, { id: 3, name: __('profile.sound_selection_option3') }, { id: 4, name: __('profile.sound_selection_option4') }], noblank: true },
                { type: 'slider', name: 'volume', label: __('profile.volume'), min: 0, max: 100, sound: "/sounds/dbo_gameon.mp3" },
                { type: 'submit', name: __('profile.save') }
            ]
        }

    }
}
</script>
